module.exports = __webpack_public_path__ + "media/bootstrap-icons/screwdriver-2807dafc.svg";